import { Component, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { MessagingService } from 'src/app/providers/messaging.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-privacy-policty',
  templateUrl: './privacy-policty.component.html',
  styleUrls: ['./privacy-policty.component.scss']
})
export class PrivacyPolictyComponent implements OnInit {

  constructor(private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private _navService: NavigationService) {
      this._navService.hideSidebarAndNav = false;
      if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
        this.messagingService.requestPermission();
      }
     }

  ngOnInit(): void {
 
  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

}
